export const getPageDefaults = ({
    initialPage,
}) => ({
    selectedPagePath: initialPage,
})
